module.exports = __webpack_public_path__ + "img/arrow-down-blue.58731871.svg";